const gamification = [
	{
		path: '/network/gamification/achievements',
		name: 'network-gamification-achievements-list',
		component: () => import('@/views/network/gamification/achievements/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGN,gamification',
		},
	},
]

export default gamification
